import "./LoadingThree.css";

const LoadingThree = () => {
  return (
    <div className="loading-three">
      <div className="loader"></div>
    </div>
  );
};
export default LoadingThree;
